export enum ResumeEducationStatus {
    InProgress = 1,
    Completed = 2,
    Starting = 3
}